import React from 'react';
import styles from './HeroImage.module.css';

const HeroImage = () => {
  const imageUrl = 'https://images.unsplash.com/photo-1543589077-47d81606c1bf?w=400&h=300&fit=crop';

  return (
    <div className={styles.hero}>
      <img src={imageUrl} alt="Calendar hero" className={styles.heroImage} />
      <div className={styles.heroOverlay}>
        <span className={styles.heroText}>Wall Calendar</span>
      </div>
    </div>
  );
};

export default HeroImage;